import {
    BASE_ORDER_EXPANSION,
    expand,
    getPurchaseFlowBFFUrl,
} from '../api/constants';
import { CheckoutState } from '../state';

export const ENABLE_CHECKOUT_EXPRESS_PAYPAL_FF =
    'checkout_enable_express_paypal';

export const POST_CHECKOUT_MANDATORY_QUESTIONS_ORGANIZATIONS_EXCLUSIONS_FF =
    'post-checkout-mandatory-questions-organizations-exclusions';

export const GROUP_WAIVER_QUESTIONS = 'checkout_group_waiver_questions';

export const ASK_REQUIRED_NON_WAIVER_QUESTIONS_AFTER_PAYMENT =
    'checkout_ask_required_non_waiver_questions_after_payment';

export const ENABLE_CAPTCHA_V3_ON_CHECKOUT = 'checkout_enable_recaptcha_v3';

export const ENABLE_GOOGLE_PAY_ON_CHECKOUT = 'checkout_enable_google_pay';

export const ENABLE_CHECKOUT_CORE_RESILIENCY_TLZ =
    'checkout_enable_core_resiliency_tlz';

export const CHECKOUT_CREATE_ORDER = 'checkout_create_order';
export const CHECKOUT_ABANDON_ORDER = 'checkout_abandon_order';
type ResilienceAction =
    | string
    | ((state: CheckoutState) => string)
    | ((state: CheckoutState) => (orderId: string) => string);

export const RESILIENCE_TLZ_ACTIONS: Record<string, ResilienceAction> = {
    [CHECKOUT_CREATE_ORDER]: (_: CheckoutState) => {
        const purchaseFlowBFFUrl = getPurchaseFlowBFFUrl();
        return `${purchaseFlowBFFUrl}api/v1/orders/create?expand=${expand(
            BASE_ORDER_EXPANSION,
        )}`;
    },
    checkout_get_attendees: 'bff_url',
    checkout_set_attendees: 'bff_url',
    [CHECKOUT_ABANDON_ORDER]: (_: CheckoutState) => {
        const purchaseFlowBFFUrl = getPurchaseFlowBFFUrl();
        return (orderId: string) =>
            `${purchaseFlowBFFUrl}api/v1/orders/${orderId}/abandon`;
    },
    checkout_get_order: 'bff_url',
    checkout_update_order: 'bff_url',
    checkout_process_order: 'bff_url',
    checkout_payments_braintree_client_token: 'bff_url',
    checkout_events_order_payments_options: 'bff_url',
    checkout_users_vault_instruments: 'bff_url',
    checkout_orders_email_preferences: 'bff_url',
    checkout_get_events_spec: 'bff_url',
    checkout_events_units_status: 'bff_url',
    checkout_events_tickets_classes_for_sale: 'bff_url',
    checkout_orders_eligibility: 'bff_url',
    checkout_reserved_pick_widget: 'bff_url',
};
